package io.horion.auth.domain.usecase

import io.horion.auth.api.models.domain.LoginMethod
import io.horion.auth.api.models.response.Response
import io.horion.auth.api.repository.AuthRepository
import io.horion.auth.api.services.ApiResponseDto
import io.horion.auth.api.services.CheckSessionResponseDto
import io.horion.auth.domain.models.SsoCodeResponse
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class AuthUseCase: KoinComponent {
    private val authRepository: AuthRepository by inject()

    suspend fun checkSession(serviceName: String?): CheckSessionResponseDto {
        return authRepository.checkSession(serviceName)
    }

    suspend fun switchAccount(userUuid: String): ApiResponseDto {
        return authRepository.switchAccount(userUuid)
    }

    suspend fun send2FaOtp(channelValue: String, method : String) : Response {
        return authRepository.send2FaOtp(channelValue,method)
    }
    suspend fun verify2FaAndEnable(channelValue: String,method: String,code: String) : Response {
        return authRepository.verify2FaAndEnable(channelValue,method,code)
    }

    suspend fun disable2FA() : Response {
        return authRepository.disable2FA()
    }

    suspend fun generateSsoCodeForMobile(): SsoCodeResponse? {
        return authRepository.generateSsoCodeForMobile()
    }

    suspend fun login(email:String, phone:String, password:String,isMobileClient : Boolean): Response {
        if (password.isBlank()) {
            return Response(false, "All fields are required")
        }

        val newEmail = email.ifEmpty { null }
        val newPhone = phone.ifEmpty { null }

        if (newEmail == null && newPhone == null) {
            return Response(
                success = false,
                message = "Email ou numéro de téléphone requis"
            )
        }

        return authRepository.login(
            email = newEmail,
            phone = newPhone,
            password = password,
            isMobileClient = isMobileClient
        )
    }

    suspend fun register(email: String, phone: String, password: String): Response {
        return authRepository.register(email, phone, password)
    }

    suspend fun verify(email:String, phone:String,method: LoginMethod): Response {
        if (email.isBlank() && phone.isBlank()) {
            return Response(false, "Email ou téléphone requis")
        }

        return authRepository.verify(email, phone, method)
    }

    suspend fun confirm(email:String, phone:String,code:String,method: LoginMethod): Response {
        if (email.isBlank() && phone.isBlank()) {
            return Response(false, "Email ou téléphone requis")
        }

        return authRepository.confirm(email,phone,code,method)
    }

    suspend fun forgotPassword(email:String, phone:String) : Response {
        if (email.isBlank() && phone.isBlank()) {
            return Response(false, "Email ou téléphone requis")
        }

        return authRepository.forgotPassword(email,phone)
    }

    suspend fun resetPassword(email:String, phone:String, code: String, newPassword: String) : Response{
        return authRepository.resetPassword(email,phone,code,newPassword)
    }

    suspend fun logout() : Response? {
        return authRepository.logout()
    }
    suspend fun logoutLocal(service : String, userUuid: String) : Response? {
        return authRepository.logoutLocal(service,userUuid)
    }
}